import React, { FC } from 'react';
import { EditCompanyView } from '../../components/EditCompanyView';

export const EditCompanyPage: FC = () => {
  return <EditCompanyView />;
};
